import { Alert, AlertProps, Snackbar } from "@mui/material";

export interface InfoSnackBarProps {
	isOpen: boolean;
	onClose: () => void;
	message: string;
	severity: AlertProps["severity"];
}

export const InfoSnackBar = ({
	message,
	onClose,
	isOpen,
	severity = "success",
}: InfoSnackBarProps): JSX.Element => (
	<Snackbar
		anchorOrigin={{ vertical: "top", horizontal: "center" }}
		open={isOpen}
		autoHideDuration={3000}
		onClose={onClose}
	>
		<Alert elevation={6} variant="filled" onClose={onClose} severity={severity}>
			{message}
		</Alert>
	</Snackbar>
);
